import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { ArticlePricesSection } from "@/pages/stammdaten/ArticlePricesSection";
import type { Article } from "@/types/camping";

export interface ArticlePricesModalProps {
  open: boolean;
  article: Article | null;
  onClose: () => void;
  onSaved: () => void;
  canEdit: boolean;
}

export function ArticlePricesModal({
  open,
  article,
  onClose,
  onSaved,
  canEdit,
}: ArticlePricesModalProps) {
  if (!article) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Preise: ${article.article_number}`}
      description={article.name}
      size="lg"
    >
      <div className="space-y-4">
        <ArticlePricesSection
          articleId={article.id}
          taxRatePercent={article.tax_rate_percent}
          canEdit={canEdit}
          onSaved={onSaved}
        />

        <div className="eh-modal-actions flex justify-end border-t border-separator pt-4">
          <Button type="button" variant="secondary" onClick={onClose}>
            Schließen
          </Button>
        </div>
      </div>
    </Modal>
  );
}
